import {BufferedEventQueue} from '../shared/util/buffered-event-queue';
import {groupBy} from 'lodash';
import {store} from '../store/global-store';
import _u from '../shared/utils';

const advertDiscoveryTrackerMixin = {
    data() {
        return {
            trackAdvertDiscoveryUrl: null,
            _intersectionObserver: undefined,
            _elementToListingMap: new WeakMap(),
        };
    },

    methods: {
        _initImpressionTracking() {
            this._initIntersectionObserver();

            this._eventQueue = new BufferedEventQueue((listings) => {
                this._trackAdvertDiscovery(listings);
            });

            this._subscribeToEvents();
        },

        _initIntersectionObserver() {
            this._intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const listing = this._elementToListingMap.get(entry.target);

                        this._eventQueue.push(listing);
                        this._intersectionObserver.unobserve(entry.target);
                    }
                });
            });
        },

        _subscribeToEvents() {
            store.subscribe(({type, payload}) => {
                if (type == 'observeListing') {
                    this._observe(payload.element, payload.listing);
                }
            });

            window.addEventListener('visibilitychange', () => {
                this._trackAdvertDiscovery(this._eventQueue.truncate());
            });
        },

        _observe(element, listing) {
            this._elementToListingMap.set(element, listing);
            this._intersectionObserver.observe(element);
        },

        _trackAdvertDiscovery(adverts) {
            if (!adverts.length) {
                return;
            }

            const listingTypeToAdvertList = groupBy(adverts, (advert) => advert.listingType);

            for (const [listingType, adverts] of Object.entries(listingTypeToAdvertList)) {
                this._trackAdvertDiscoveryForListingType(adverts.map((advert) => advert.id), listingType);
            }
        },

        _trackAdvertDiscoveryForListingType(advertIds, listingType) {
            let url = this.trackAdvertDiscoveryUrl;
            url = _u.addQueryParamForUrl(url, 'discoveryKind', 'impression');
            url = _u.addQueryParamForUrl(url, 'listingType', listingType);

            _u.sendAnalytics(url, advertIds);
        },
    },

    mounted() {
        this._initImpressionTracking();
    },
};

export {advertDiscoveryTrackerMixin};
